import { useState } from 'react';
import { Icon } from 'react-icons-kit';
import { eye } from 'react-icons-kit/feather/eye';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { Link, useNavigate } from 'react-router-dom';

import Logo from '../../assets/logo-dark.png';
import Loading from '../../components/Loading/Loading.jsx';
import { registerUser } from '../../lib/firebase/Authentication/EmailAuth/index.js';
import { signUpWithGoogle } from '../../lib/firebase/Authentication/GoogleAuth/index.js';
import Styles from '../../styles/Auth.module.css';

const Signup = ({ setAuth }) => {
  const [usernameError, setUsernameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [usernameIsTaken, setUsernameIsTaken] = useState(false);
  const [usernameIsUnavailable, setUsernameIsUnavailabe] = useState(false);
  const [emailIsUsed, setEmailIsUsed] = useState(false);
  const [googleError, setGoogleError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(eyeOff);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
  });

  const { username, email, password } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleToggleEye = () => {
    if (type === 'password') {
      setIcon(eye);
      setType('text');
    } else {
      setIcon(eyeOff);
      setType('password');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    registerUser(
      username,
      email,
      password,
      setIsLoading,
      navigate,
      setUsernameError,
      setEmailError,
      setPasswordError,
      setUsernameIsTaken,
      setUsernameIsUnavailabe,
      setEmailIsUsed,
    );
  };

  const handleGoogleSignup = () => {
    setGoogleError('');
    signUpWithGoogle(navigate, setIsLoading);
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className={Styles.page}>
      <div className={Styles.headerContainer}>
        <img
          className={Styles.logoIcon}
          src={Logo}
          alt={'Website logo'}
          onClick={() => navigate('/')}
        />
        <div className={Styles.headerActions}>
          <button
            type="button"
            className={Styles.headerBtn}
            onClick={() => navigate('/login')}
          >
            Log in
          </button>
        </div>
      </div>
      <div className={Styles.container}>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className={Styles.title}>
            <h1>Sign Up</h1>
          </div>
          <div className={Styles.inputs}>
            <label>Username</label>
            <div className={Styles.input}>
              <input
                type="text"
                name="username"
                value={username}
                onChange={onChange}
              />
            </div>
            <div className={Styles.errorContainer}>
              {usernameError ? (
                <p>
                  Username must be between 6 and 20 characters and contain
                  letters, numbers, or underscores.
                </p>
              ) : usernameIsTaken ? (
                <p>Username already taken.</p>
              ) : usernameIsUnavailable ? (
                <p>Username is unavailble.</p>
              ) : (
                <></>
              )}
            </div>
            <label>Email</label>
            <div className={Styles.input}>
              <input
                type="text"
                name="email"
                value={email}
                onChange={(e) => onChange(e)}
              />
            </div>
            <div className={Styles.errorContainer}>
              {emailError ? (
                <p>Invalid email format.</p>
              ) : emailIsUsed ? (
                <p>Email is already in use.</p>
              ) : (
                <></>
              )}
            </div>
            <label>Password</label>
            <div className={Styles.input}>
              <input
                type={type}
                name="password"
                value={password}
                onChange={(e) => onChange(e)}
              />
              <Icon
                className={Styles.eye}
                icon={icon}
                size={20}
                onClick={handleToggleEye}
              />
            </div>
            <div className={Styles.errorContainer}>
              {passwordError ? (
                <p>Password must be between 8 and 25 characters.</p>
              ) : (
                <></>
              )}
            </div>
          </div>
          <button type="submit" className={Styles.signupBtn}>
            Sign up
          </button>
          <p className={Styles.orSeparator}>
            <span>OR</span>
          </p>
        </form>
        <button
          type="button"
          className={Styles.loginWithGoogleBtn}
          onClick={handleGoogleSignup}
        >
          Sign in with Google
        </button>
        {googleError && (
          <div className={Styles.errorContainer}>
            <p>{googleError}</p>
          </div>
        )}
        <p className={Styles.switchPrompt}>
          Already have an account?
          <Link to="/login" className={Styles.switchLink}>
            Log in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;